module.exports = __webpack_public_path__ + "img/bgg1@3x.5fa39f0b.png";